<script>
  import queryString from "query-string";
  import { onMount } from "svelte"
  import { apiPost } from "../httpCommon";

  let state;
  let resp

  onMount(async () => {
      state = 'processing';
      const queryParams = queryString.parse(window.location.search)
      try {
          resp = await apiPost('customer/unsubscribe-menu', queryParams)
          state = 'unsubscribed';
      } catch (err) {

          state = 'error';
      }
  })

</script>
<style>

  .outer {
    width: 922px;
    margin: auto;
  }
  .message {
      margin-top: 100px;
  }

  h3 {
      text-align: center;
  }
</style>
<div class="outer">
    {#if state == 'processing'}
        <h3 class="message">processing</h3>
    {:else if state == 'unsubscribed'}
        {#if resp}
            <h3 class="message">We’re sorry to see you go!</h3>
            <h3>You’ve been unsubscribed from Food Disco’s menu emails for {resp.venue_name}</h3>
            <h3>Re-subscribe at any time via our homepage or just tick the box when you order next</h3>
        {:else}
            <h3 class="message">You are already unsubscribed from Food Disco’s menu emails for this venue</h3>
            <h3>Re-subscribe at any time via our homepage or just tick the box when you order next</h3>
        {/if}
    {:else if state == 'error'}
        <h3 class="message">There was an error processing your unsubscribtion request.<br />
        Please contact <a href="mailto:info@fooddisco.co.uk">info@fooddisco.co.uk</a>
        </h3>
    {/if}
</div>